const videoSubmissionStates = {
  new: 'new',
  viewed: 'viewed',
  awaiting_editing: 'awaiting_editing',
  purchased: 'purchased'
}

const videoSubmissionContexts = {
  purchaseable: [
    videoSubmissionStates.new,
    videoSubmissionStates.viewed,
  ]
}

interface Submission {
  state: string
  type: string
}

export function submissionInContext(submission: Partial<Submission>, contextOrState: string): boolean {
  switch (submission.type) {
    case 'VideoSubmission':
      return _videoSubmissionInContext(submission, contextOrState, videoSubmissionContexts)
    default:
      return false
  }
}

function _videoSubmissionInContext(submission: Partial<Submission>, contextOrState: string, videoSubmissionContexts: any): boolean {
  return videoSubmissionContexts.hasOwnProperty(contextOrState) ?
    videoSubmissionContexts[contextOrState].includes(submission.state) :
    submission.state === contextOrState
}
